
export const ConfirmationDialogText = {
    "delete_activity_category": { title: "Please confirm", body: "Do you really want to delete this activity category?", okButtonText: "Delete", cancelButtonText: "Cancel" },
    "delete_activity_categories": { title: "Please confirm", body: "Do you really want to delete these activity categories?", okButtonText: "Delete", cancelButtonText: "Cancel" },
}
